import React from 'react';
import { Select, InputNumber, Input } from '../../Common';
import {
    Grid,
    FormControl,
    FormControlLabel,
    FormLabel,
    RadioGroup,
    Radio,
} from '@mui/material';

const vacuumOptions = [
    { id: true, label: "Yes" },
    { id: false, label: "No" }
];

const ShutdownFields = ({
    isChecked,
    disabled,
    shutdownDetail,
    onFieldChange,
    dropDownOptions
}) => {
    const {
        wasRefrigerantRecovered,
        postShutdownStatusId,
        cylinderId,
        transferAmount,
        transferAmountError,
        recoverGasStatusId,
        cylinderNotes,
        transferNotes,
        recoveryEquipmentId,
        wasProperVacuumPulled,
        vacuumPsi,
    } = shutdownDetail || {};

    const showPostShutdownStatus = wasRefrigerantRecovered !== null && wasRefrigerantRecovered !== undefined;
    const showRecoveryFields = wasRefrigerantRecovered === true;

    return (
        <>
            <Grid item xs={12}>
                <FormControl required sx={{ fontSize: "14px" }} disabled={disabled || !isChecked}>
                    <FormLabel sx={{ fontSize: "14px", mb: 1 }}>Was refrigerant recovered from system?</FormLabel>
                    <RadioGroup
                        row
                        onChange={e => onFieldChange("wasRefrigerantRecovered", e.target.value === "true")}
                        value={wasRefrigerantRecovered}
                        aria-labelledby="row-radio-buttons-group-label"
                        sx={{ ml: 2 }}
                    >
                        <FormControlLabel value={"true"} control={<Radio />} label="Yes" />
                        <FormControlLabel value={"false"} control={<Radio />} label="No" />
                    </RadioGroup>
                </FormControl>
            </Grid>
            {showPostShutdownStatus && (
                <Grid item xs={12} md={4}>
                    <Select
                        required
                        variant="outlined"
                        label="Post Shutdown Status"
                        value={postShutdownStatusId || ''}
                        onChange={e => onFieldChange("postShutdownStatusId", e.target.value)}
                        options={dropDownOptions.postShutdownStatuses}
                    />
                </Grid>
            )}
            {showRecoveryFields && (
                <>
                    <Grid item xs={12} md={4}>
                        <Select
                            required
                            variant="outlined"
                            label="Cylinder"
                            value={cylinderId ?? ''}
                            onChange={e => onFieldChange("cylinderId", e.target.value)}
                            options={dropDownOptions.cylinders}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <InputNumber
                            fullWidth
                            hideStepper
                            allowDecimal
                            required
                            label="Transfer Amount (lbs)"
                            variant="outlined"
                            value={transferAmount || ''}
                            onChange={e => onFieldChange("transferAmount", e.target.value)}
                            error={transferAmountError}
                            helperText={transferAmountError &&
                                'Transfer Amount must be less than the current gas charge'
                            }
                        />
                    </Grid>
                    {(cylinderId === 0) && (
                        <Grid item xs={12} md={4}>
                            <Select
                                required
                                variant="outlined"
                                label="Status of Recover Gas"
                                value={recoverGasStatusId || ''}
                                onChange={e => onFieldChange("recoverGasStatusId", e.target.value)}
                                options={dropDownOptions.recoverGasStatuses}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} md={6}>
                        <Input
                            fullWidth
                            label="Cylinder Notes"
                            variant="outlined"
                            value={cylinderNotes || ''}
                            onChange={e => onFieldChange("cylinderNotes", e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Input
                            fullWidth
                            label="Transfer Notes"
                            variant="outlined"
                            value={transferNotes || ''}
                            onChange={e => onFieldChange("transferNotes", e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Select
                            variant="outlined"
                            label="Recovery Equipment Used"
                            value={recoveryEquipmentId || ''}
                            onChange={e => onFieldChange("recoveryEquipmentId", e.target.value)}
                            options={dropDownOptions.recoveryEquipment}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Select
                            required
                            variant="outlined"
                            label="Was Appropriate Vacuum Pulled?"
                            value={wasProperVacuumPulled ?? ''}
                            onChange={e => onFieldChange("wasProperVacuumPulled", e.target.value)}
                            options={vacuumOptions}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <InputNumber
                            fullWidth
                            hideStepper
                            allowDecimal
                            label="Vacuum of HG (inHg)"
                            variant="outlined"
                            value={vacuumPsi || ''}
                            onChange={e => onFieldChange("vacuumPsi", e.target.value)}
                        />
                    </Grid>
                </>
            )}
        </>
    );
};

export default ShutdownFields;
